var _g, _mask, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightImgPinPartner56 = function SvgLightImgPinPartner56(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 38,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#light_img_pin_partner_56_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.01,
    fillRule: "evenodd",
    d: "M9 3a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16.546l2.152 3.383a1 1 0 0 0 1.687 0L31.538 27H49a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "light_img_pin_partner_56_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 3a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h17.227l3.93 6.174a1 1 0 0 0 1.687 0L33.773 27H51a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#09F",
    fillRule: "evenodd",
    d: "M7 3a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h17.227l3.93 6.174a1 1 0 0 0 1.687 0L33.773 27H51a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0072BE",
    d: "m24.227 27 .844-.537a1 1 0 0 0-.844-.463zm3.93 6.174-.844.537zm1.687 0L29 32.637zM33.773 27v-1a1 1 0 0 0-.844.463zM4 7a3 3 0 0 1 3-3V2a5 5 0 0 0-5 5zm0 16V7H2v16zm3 3a3 3 0 0 1-3-3H2a5 5 0 0 0 5 5zm17.227 0H7v2h17.227zM29 32.637l-3.93-6.174-1.686 1.074 3.929 6.174zm0 0-1.687 1.074a2 2 0 0 0 3.374 0zm3.93-6.174L29 32.637l1.687 1.074 3.93-6.174zM51 26H33.773v2H51zm3-3a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm0-16v16h2V7zm-3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zM7 4h44V2H7z",
    mask: "url(#light_img_pin_partner_56_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M35.667 14.141v1.36h-1.392l-1.294 5.03h-1.504l-1.327-5.03h-1.504c-.42 1.633-.906 3.38-1.343 5.03h-1.52l-1.279-5.03H23v-1.36h1.18c-.323-1.31-.662-2.847-.97-4.141H24.7l.954 4.141h1.893L28.565 10h1.634l1.019 4.141h1.909c.323-1.326.647-2.815.97-4.141h1.505l-1.003 4.141zm-3.462 3.77.598-2.41H31.59c.21.873.372 1.487.615 2.41m-5.646-.017.647-2.394h-1.23zm2.426-3.753h.826c-.162-.614-.243-.873-.421-1.569-.13.534-.275 1.003-.405 1.57",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "light_img_pin_partner_56_svg__a",
    width: 58,
    height: 37.846,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.313151 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_115_967"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_115_967",
    result: "shape"
  })))));
};
export default SvgLightImgPinPartner56;